import { apiClient } from '@/services/api-client';
import { ProviderTeam } from '@/types/provider-teams';

interface ProviderTeamsApiPayload {
  data: Array<{
    id: string;
    type?: string;
    attributes?: Record<string, unknown>;
    [key: string]: unknown;
  }>;
}

const toTeam = (resource: ProviderTeamsApiPayload['data'][number]): ProviderTeam => {
  const attributes = resource.attributes && typeof resource.attributes === 'object' ? resource.attributes : resource;

  return {
    id: resource.id,
    name: String(attributes.name ?? ''),
    description: typeof attributes.description === 'string' ? attributes.description : null,
    slug: String(attributes.slug ?? ''),
    maxSeats: typeof attributes.max_seats === 'number' ? attributes.max_seats : typeof attributes.maxSeats === 'number' ? attributes.maxSeats : null,
    status: String(attributes.status ?? 'active'),
    createdAt: String(attributes.created_at ?? attributes.createdAt ?? ''),
    ownerCustomerId: typeof resource.relationships === 'object'
      ? (() => {
          const ownerData = (resource.relationships as Record<string, unknown>).owner as
            | { data?: { id?: string } | null }
            | undefined;
          if (ownerData && ownerData.data && typeof ownerData.data === 'object') {
            return (ownerData.data as { id?: string }).id ?? null;
          }
          return null;
        })()
      : null,
  };
};

class ProviderTeamsService {
  async list(): Promise<ProviderTeam[]> {
    const response = await apiClient.get<ProviderTeamsApiPayload>('/api/v1/teams');
    const payload = response.data ?? { data: [] };
    const resources = Array.isArray(payload.data) ? payload.data : [];
    return resources.map(toTeam);
  }
}

export const providerTeamsService = new ProviderTeamsService();
